// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: llm_settings.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "llm_settings";

/** Main proto definition */
export interface LLMSettings {
  modelId: string;
  updatedBy?: string | undefined;
  updatedAt?: Date | undefined;
}

/** commands */
export interface LLMSettingsUpdateLLMSettings {
  modelId: string;
}

function createBaseLLMSettings(): LLMSettings {
  return { modelId: "", updatedBy: undefined, updatedAt: undefined };
}

export const LLMSettings: MessageFns<LLMSettings> = {
  encode(message: LLMSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(18).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LLMSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLLMSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LLMSettings {
    return {
      modelId: isSet(object.modelId)
        ? globalThis.String(object.modelId)
        : isSet(object.model_id)
        ? globalThis.String(object.model_id)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: LLMSettings): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<LLMSettings>): LLMSettings {
    return LLMSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LLMSettings>): LLMSettings {
    const message = createBaseLLMSettings();
    message.modelId = object.modelId ?? "";
    message.updatedBy = object.updatedBy ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseLLMSettingsUpdateLLMSettings(): LLMSettingsUpdateLLMSettings {
  return { modelId: "" };
}

export const LLMSettingsUpdateLLMSettings: MessageFns<LLMSettingsUpdateLLMSettings> = {
  encode(message: LLMSettingsUpdateLLMSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelId !== "") {
      writer.uint32(10).string(message.modelId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LLMSettingsUpdateLLMSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLLMSettingsUpdateLLMSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LLMSettingsUpdateLLMSettings {
    return {
      modelId: isSet(object.modelId)
        ? globalThis.String(object.modelId)
        : isSet(object.model_id)
        ? globalThis.String(object.model_id)
        : "",
    };
  },

  toJSON(message: LLMSettingsUpdateLLMSettings): unknown {
    const obj: any = {};
    if (message.modelId !== "") {
      obj.modelId = message.modelId;
    }
    return obj;
  },

  create(base?: DeepPartial<LLMSettingsUpdateLLMSettings>): LLMSettingsUpdateLLMSettings {
    return LLMSettingsUpdateLLMSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LLMSettingsUpdateLLMSettings>): LLMSettingsUpdateLLMSettings {
    const message = createBaseLLMSettingsUpdateLLMSettings();
    message.modelId = object.modelId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
